import "./InlineButtonPlaceholder.scss";

export const InlineButtonPlaceholder = () => {
  return <span className={"inline-button-placeholder"} />;
};
